import { Nullable } from '@homeserve/od-typings/utils';
import siret from 'siret';
import { Validator } from 'vee-validate';

export default function isValidSIREN(value: Nullable<string>): boolean {
  if (!value) {
    return false;
  }

  return siret.isSIREN(value);
}

Validator.extend('siren', isValidSIREN);
